import * as React from 'react';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import 'video-react/dist/video-react.css';

interface VideoPlayerProps {
	url: string;
}

class VideoPlayer extends React.Component<VideoPlayerProps, {}> {
	videoElement: HTMLVideoElement;

	render() {
		const { url } = this.props;

		return (
			<Player
				autoPlay={true}
				playsInline={true}
				fluid={false}
				height={'100%'}
				src={url}
			>
				<BigPlayButton position="center" />
				<ControlBar autoHide={false}/>
			</Player>
		);
	}
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/VideoPlayer/index.tsx